import React, { FunctionComponent } from 'react';
import { Heading } from '../../shared/Heading';
// import { Link } from '../../shared/Link';
import './WithdrawalCheck.scss';
import { useTranslations } from '../../../hooks/useTranslationsHelper';
import { useUserBalance } from '../../../hooks/useUserBalance';
import { useDispatch } from 'react-redux';
import { setCashierModal } from '../../../state/cashier/reducers';
import { CashierType } from '../../../state/cashier';
import { Button } from '../../shared/Button';

type WithdrawalCheckProps = {
  /**
   * Heading of the component
   */
  heading: string;
  /**
   * Link's label
   */
  linkText: string;
  /**
   * Component internal content part
   */
  children: React.ReactNode;
};

/**
 * Component to encourage customer to withdraw before account closure
 */
export const WithdrawalCheck: FunctionComponent<WithdrawalCheckProps> = ({ heading, children, linkText }) => {
  const { t } = useTranslations();
  const { userBalance } = useUserBalance();
  const dispatch = useDispatch();

  const onClick = (): void => {
    dispatch(setCashierModal({ isOpen: true, type: CashierType.Withdrawal, amount: userBalance.mainCashBalance }));
  };

  return (
    <div className="withdrawal-check">
      {userBalance.mainCashBalance > 0 && (
        <>
          <Heading className="withdrawal-check__heading" level={6}>
            {heading}
          </Heading>
          <Button type="button" variant="betzone-alt" onClick={onClick}>
            {linkText}
          </Button>
          {/*<Link onClick={onClick}>{linkText}</Link>*/}
        </>
      )}
      {userBalance.mainCashBalance > 0 && <Heading level={6}>{t('self-exclusion.withdraw-note')}</Heading>}
      {children}
    </div>
  );
};
